// Shared so SideMenuTemplate, Router and the view itself can't drift on
// rename. SideMenuTemplate cannot import from FrDiagnosticsView directly
// (PageTemplate -> PrimaryNavigation -> SideMenuTemplate creates a cycle), so
// this constant lives in its own module that all three can pull in.
//
// Mirrors the CampanionStaffAccessView/constants.ts precedent.
export const CONFIGCAT_FLAG_KEY = 'frPersonDiagnosticsEnabled'

export const FR_DIAGNOSTICS_PATH = '/fr-diagnostics'
